export function getDocumentVehicles(policyNumber) {
  return {
    type: 'GET_DOCUMENT_VEHICLES',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            mock: false,
            base: '/vehicles/getVehicles',
            query: [
              {
                name: 'policyNumber',
                value: policyNumber,
              },
            ],
          },
        },
        commit: {
          type: 'GET_DOCUMENT_VEHICLES_COMMIT',
        },
        rollback: {
          type: 'GET_DOCUMENT_VEHICLES_ROLLBACK',
        },
      },
    },
  }
}

export function removeDocumentVehicle(vehicleId, documentId, documentType) {
  return {
    type: 'REMOVE_DOCUMENT_VEHICLE',
    payload: {
      vehicleId,
      documentId,
      documentType,
    },
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/vehicles/removeVehicle',
          },
        },
        commit: {
          type: 'REMOVE_DOCUMENT_VEHICLE_COMMIT',
        },
        rollback: {
          type: 'REMOVE_DOCUMENT_VEHICLE_ROLLBACK',
        },
      },
    },
  }
}

export function addDocumentVehicle(vehicle) {
  return {
    type: 'ADD_DOCUMENT_VEHICLE',
    payload: vehicle,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/vehicles/addVehicle',
          },
        },
        commit: {
          type: 'ADD_DOCUMENT_VEHICLE_COMMIT',
        },
        rollback: {
          type: 'ADD_DOCUMENT_VEHICLE_ROLLBACK',
        },
      },
    },
  }
}

export function setDocumentVehicle(vehicle) {
  return {
    type: 'SET_DOCUMENT_VEHICLE',
    payload: { vehicle },
  }
}
